(() => {
  const BUTTON_SELECTOR = '[data-paws-buy-now]';

  if (window.PawsBuyNowLoaded) return;
  window.PawsBuyNowLoaded = true;

  const findForm = (button) => {
    const formId = button.getAttribute('data-form-id');
    return (formId && document.getElementById(formId)) || button.closest('form');
  };

  const getVariantInput = (form) => form?.querySelector('[name="id"]');

  const getQuantity = (form) => {
    const quantity = Number.parseInt(form?.querySelector('[name="quantity"]')?.value, 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  };

  const isUnavailable = (button, form) => {
    const variantInput = getVariantInput(form);
    const submitButton = form?.querySelector('[name="add"]');

    return (
      !variantInput?.value ||
      variantInput.disabled ||
      submitButton?.disabled ||
      submitButton?.getAttribute('aria-disabled') === 'true'
    );
  };

  const syncButton = (button) => {
    if (button.dataset.loading === 'true') return;

    const unavailable = isUnavailable(button, findForm(button));
    button.disabled = unavailable;
    button.setAttribute('aria-disabled', String(unavailable));
  };

  const syncButtons = () => {
    document.querySelectorAll(BUTTON_SELECTOR).forEach(syncButton);
  };

  const appendInput = (form, name, value) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  };

  const submitDirectlyToCheckout = (button, productForm) => {
    const variantId = getVariantInput(productForm)?.value;
    if (!variantId) return;

    button.dataset.loading = 'true';
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-busy', 'true');

    const label = button.querySelector('[data-paws-buy-now-label]') || button.querySelector('span');
    if (label) {
      button.dataset.idleLabel = label.textContent;
      label.textContent = button.dataset.loadingLabel || 'Redirecting…';
    }

    const checkoutForm = document.createElement('form');
    checkoutForm.method = 'post';
    checkoutForm.action = window.routes?.cart_add_url || '/cart/add';
    checkoutForm.hidden = true;

    appendInput(checkoutForm, 'form_type', 'product');
    appendInput(checkoutForm, 'utf8', '✓');
    appendInput(checkoutForm, 'id', variantId);
    appendInput(checkoutForm, 'quantity', String(getQuantity(productForm)));
    appendInput(checkoutForm, 'return_to', '/checkout');

    document.body.appendChild(checkoutForm);
    requestAnimationFrame(() => checkoutForm.submit());
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(BUTTON_SELECTOR);
    if (!button) return;

    event.preventDefault();
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    const form = findForm(button);
    if (isUnavailable(button, form)) {
      syncButton(button);
      return;
    }

    submitDirectlyToCheckout(button, form);
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[name="id"], [name="quantity"]')) requestAnimationFrame(syncButtons);
  });
  document.addEventListener('variant:change', () => requestAnimationFrame(syncButtons));
  window.addEventListener('pageshow', syncButtons);

  syncButtons();
})();
